import { FC, useState } from 'react';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import useTaxReportDownload from 'hooks/useTaxReportDownload';

type Props = {
  taxYearStart: number;
  investorId: string;
  hasReport: boolean;
};

const DownloadTaxReportButton: FC<Props> = ({
  taxYearStart,
  investorId,
  hasReport,
}) => {
  const { downloadReport } = useTaxReportDownload();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await downloadReport(taxYearStart, investorId);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Tooltip
      title={
        !hasReport ? 'This investor had no taxable events within the year.' : ''
      }
    >
      <IconButton
        onClick={handleDownload}
        disabled={isDownloading}
        size="small"
      >
        {isDownloading ? (
          <CircularProgress size={20} />
        ) : (
          <CloudDownload color={hasReport ? 'primary' : 'disabled'} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default DownloadTaxReportButton;
